import React, { useState, useEffect } from 'react';
import './App.css';

// Define TypeScript interfaces
interface Product {
  id: string;
  name: string;
  image: string;
  url: string;
  description: string;
}

interface ProductCategory {
  title: string;
  products: Product[];
}

const App = () => {
  const [loading, setLoading] = useState<boolean>(true);
  const [imageErrors, setImageErrors] = useState<{[key: string]: boolean}>({});
  const [isMobile, setIsMobile] = useState<boolean>(window.innerWidth < 768);
const [currentYear, setCurrentYear] = useState<number>(new Date().getFullYear());

  // Handle window resize
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Product data with names, images and URLs
  const productCategories: ProductCategory[] = [
    {
      title: "Bulldozer",
      products: [
        {
          id: "dh08",
          name: "DH-08",
          image: "https://www.gmtractors.net/admin_gmt/view/setup_content/product/uploader/DH08B2XL.jpg",
          url: "https://shantui.gmtractors.net/dh08/",
          description: "Compact and efficient mini bulldozer with advanced features for small to medium construction projects."
        },
        {
           id: "sd22",
          name: "SD-22",
          image: "https://www.gmtractors.net/admin_gmt/view/setup_content/product/uploader/80565b128ccf1408d4b7b9424b28b8fd.jpg",
          url: "https://shantui.gmtractors.net/sd22/",
          description: "Powerful medium-sized bulldozer for construction and mining applications."
        },
        // {
        //   id: "dh10",
        //   name: "DH-10",
        //   image: "https://www.gmtractors.net/admin_gmt/view/setup_content/product/uploader/DH10B2XL.jpg",
        //   url: "https://shantui.gmtractors.net/dh10/",
        //   description: "Premium mini bulldozer designed for heavy duty work and challenging terrains."
        // },
        // {
        //   id: "dh11",
        //   name: "DH-11",
        //   image: "https://www.gmtractors.net/admin_gmt/view/setup_content/product/uploader/DH11B2XL.jpg",
        //   url: "https://shantui.gmtractors.net/dh11/",
        //   description: "Latest model with smart features and improved operator comfort."
        // }
      ]
    },
    // {
    //   title: "Medium Bulldozer",
    //   products: [
    //     {
    //       id: "sd22",
    //       name: "SD-22",
    //       image: "https://www.gmtractors.net/admin_gmt/view/setup_content/product/uploader/80565b128ccf1408d4b7b9424b28b8fd.jpg",
    //       url: "https://shantui.gmtractors.net/sd22/",
    //       description: "Powerful medium-sized bulldozer for construction and mining applications."
    //     },
    //     {
    //       id: "sd23",
    //       name: "SD-23",
    //       image: "https://www.gmtractors.net/admin_gmt/view/setup_content/product/uploader/SD23B2XL.jpg",
    //       url: "https://shantui.gmtractors.net/sd23/",
    //       description: "Enhanced medium bulldozer with superior performance and reliability."
    //     },
    //     {
    //       id: "sd24",
    //       name: "SD-24",
    //       image: "https://www.gmtractors.net/admin_gmt/view/setup_content/product/uploader/SD24B2XL.jpg",
    //       url: "https://shantui.gmtractors.net/sd24/",
    //       description: "Robust bulldozer designed for large-scale construction projects."
    //     },
    //     {
    //       id: "sd25",
    //       name: "SD-25",
    //       url: "https://shantui.gmtractors.net/sd25/",
    //       image: "https://www.gmtractors.net/admin_gmt/view/setup_content/product/uploader/SD25B2XL.jpg",
    //       description: "Professional grade medium bulldozer with advanced hydraulic systems."
    //     }
    //   ]
    // }
  ];

  // Fallback images for error handling
  const fallbackImages: {[key: string]: string} = {
    dh08: `${process.env.PUBLIC_URL}/fallback-dh08.jpg`,
    // dh09: `${process.env.PUBLIC_URL}/fallback-dh09.jpg`,
    // dh10: `${process.env.PUBLIC_URL}/fallback-dh10.jpg`,
    // dh11: `${process.env.PUBLIC_URL}/fallback-dh11.jpg`,
    // sd22: `${process.env.PUBLIC_URL}/fallback-sd22.jpg`,
    // sd23: `${process.env.PUBLIC_URL}/fallback-sd23.jpg`,
    // sd24: `${process.env.PUBLIC_URL}/fallback-sd24.jpg`,
    // sd25: `${process.env.PUBLIC_URL}/fallback-sd25.jpg`,
    default: `${process.env.PUBLIC_URL}/fallback-default.jpg`
  };

  const handleProductClick = (url: string): void => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const handleImageError = (productId: string): void => {
    setImageErrors(prev => ({ ...prev, [productId]: true }));
  };

  const handleImageLoad = (): void => {
    setLoading(false);
  };

  const getImageSource = (product: Product): string => {
    return imageErrors[product.id] 
      ? (fallbackImages[product.id] || fallbackImages.default)
      : product.image;
  };

  return (
    <div className="landing-page">
      {/* Logo Header with White Background */}
      <header className="logo-header">
        <div className="logo-container">
          <div className="logo-wrapper">
            <img 
              src={`${process.env.PUBLIC_URL}/gmt-logo.png`} 
              alt="GMT Tractors Logo" 
              className="gmt-logo"
              onError={(e) => {
                const target = e.target as HTMLImageElement;
                target.style.display = 'none';
              }}
            />
           
          </div>
        </div>
      </header>

      {/* Hero Section with Yellow Gradient */}
      <section className="hero-section" style={{ 
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${process.env.PUBLIC_URL}/bg.jpg)`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}>
        <div className='logo-wrapper'>
           <img
              src={`${process.env.PUBLIC_URL}/shantuiw-logo.png`} 
              className="shantui-logo"
              alt="Shantui logo"
            />
        </div>
        <div className="hero-content" >
          <h1 className="hero-title">Premium Bulldozer</h1>
          <p className="hero-subtitle">Value That Works.</p>
          {/* <div className="hero-features">
            <span className="hero-feature">⚡ High Performance</span>
            <span className="hero-feature">🛡️ Durable Build</span>
            <span className="hero-feature">💰 Cost Effective</span>
          </div> */}
          
          {/* {isMobile && (
            <button 
              className="cta-button hero-cta"
              onClick={() => {
                const firstProduct = productCategories[0].products[0];
                handleProductClick(firstProduct.url);
              }}
            >
              View Our Products
            </button>
          )} */}
        </div>

        {/* Scroll Indicator for Desktop */}
        {/* {!isMobile && (
          <div className="scroll-indicator">
            <span>Scroll to Explore</span>
            <div className="scroll-arrow"></div>
          </div>
        )} */}
      </section>

      {/* Main Content */}
      <main className="main-content">
        {/* Product Categories */}
        {productCategories.map((category, index) => (
          <section key={category.title} className="product-category-section">
            <div className="container">
              <h2 className="category-title">{category.title}</h2>
              <p className="category-description">
                Discover our range of high-performance {category.title.toLowerCase()} designed for efficiency and durability.
              </p>
              
              <div className="products-grid">
                {category.products.map((product) => (
                  <article 
                    key={product.id}
                    className="product-card"
                    onClick={() => handleProductClick(product.url)}
                  >
                    <div className="product-image-container">
                      {loading && (
                        <div className="image-loading">
                          <div className="loading-spinner"></div>
                          <span>Loading...</span>
                        </div>
                      )}
                      <img 
                        src={getImageSource(product)}
                        alt={product.name}
                        className="product-image"
                        onError={() => handleImageError(product.id)}
                        onLoad={handleImageLoad}
                        loading="lazy"
                      />
                      <div className="product-overlay">
                        <button className="view-product-btn">
                          View Details
                        </button>
                      </div>

                      {/* <div className="product-badge">New</div> */}
                    </div>
                    
                    <div className="product-info">
                      <h3 className="product-name">{product.name}</h3>
                      <p className="product-description">{product.description}</p>
                      {/* <div className="product-features">
                        <span className="feature-tag">Heavy Duty</span>
                        <span className="feature-tag">Eco Friendly</span>
                      </div> */}
                    </div>
                  </article>
                ))}
              </div>
            </div>
            
            {index < productCategories.length - 1 && (
              <div className="category-divider"></div>
            )}
          </section>
        ))}

        {/* Contact/Footer Section */}
        <footer className="footer">
          <div className="container">
            <div className="footer-content">
              <div className="contact-info">
                <h3>Contact Us</h3>
                <div className="contact-details">
                  <div className="contact-item">
                    <strong>PT Gaya Makmur Tractors</strong>
                  </div>
                  <div className="contact-item">
                    <span className="contact-icon">📍</span>
                    <span>Jl Lingkar Luar Barat No 3, Rawa Buaya - Cengkareng - Jakarta Barat 11730</span>
                  </div>
                  <div className="contact-item">
                    <span className="contact-icon">📧</span>
                    <span>wismoyo.panangian@gmtractors.net</span>
                  </div>
                  <div className="contact-item">
                    <span className="contact-icon">📞</span>
                    <span>+62 812-2516-4935</span>
                  </div>
                </div>
              </div>
              
              <div className="footer-cta">
                <h4>Ready to Get Started?</h4>
                <p>Contact us for a free consultation and quote</p>
                <button 
                  className="cta-button"
                  onClick={() => window.open('mailto:wismoyo.panangian@gmtractors.net')}
                >
                  Get In Touch
                </button>
              </div>
            </div>
            
            <div className="footer-bottom">
               <p>&copy; 2024 - {currentYear} PT Gaya Makmur Tractors. All rights reserved.</p>
            </div>
          </div>
        </footer>
      </main>
    </div>
  );
};

export default App;